import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface Props {
  setOpenModal: () => void;
}

/**
 * Popup di presa in carico dell'archiviazione massiva Watch List (LPP-23094 / Task-SCFE-1).
 * L'elaborazione è asincrona: l'esito è scaricabile dalla sezione "Esportazioni Watch List".
 */
const MassiveArchiveModal = (props: Props) => {
  const { t } = useTranslation(["finessecurity"]);

  return (
    <Mui.Dialog open={true} maxWidth={"md"}>
      <Mui.DialogTitle>
        <Mui.Grid container alignItems="center" direction="row" spacing={1}>
          <Mui.Grid item sx={{ display: "flex" }}>
            <MuiIcons.CheckCircle sx={{ color: "green" }} />
          </Mui.Grid>
          <Mui.Grid xs item>
            <Mui.Typography variant="h5">
              {t("blackList.massiveArchive.title")}
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item sx={{ justifyContent: "flex-end", display: "flex" }}>
            <MuiIcons.Close
              color="disabled"
              fontSize="small"
              onClick={props.setOpenModal}
            />
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>
      <Mui.DialogContent>
        <Mui.Box>{t("blackList.massiveArchive.body")}</Mui.Box>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Grid
          container
          alignItems="center"
          alignContent="center"
          direction="row"
        >
          <Mui.Grid>
            <Mui.Link href="/finessecurity/watchlistexports">
              {t("blackList.massiveArchive.footer")}
            </Mui.Link>
          </Mui.Grid>
          <Mui.Grid
            xs
            item
            sx={{ display: "flex", justifyContent: "flex-end" }}
            pr={2}
          >
            <Mui.Stack direction="row" spacing={2.5}>
              <Mui.Button onClick={props.setOpenModal}>
                <Mui.Typography variant="h6" color="inherit">
                  {t("buttons.close")}
                </Mui.Typography>
              </Mui.Button>
            </Mui.Stack>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default MassiveArchiveModal;
